<template>
  <div>
    <h1 class="display-3">Kontakt</h1><br/>
    <b-row>
      <b-col xl="5">
        <b>Projekt i realizacja:</b><a href="https://pl.linkedin.com/in/boni0" target="_blank"> Dawid Bonik</a><br/>
        <b>
          Administratorem strony jest Fundacja Ośrodka KARTA.
        </b><br/>
        Fundacja Ośrodka KARTA<br/>
        ul. Narbutta 29<br/>
        02-536 Warszawa<br/>
        Tel. (022) 848-07-12<br/>
        <a href="mailto:adres ok@karta.org.pl">ok@karta.org.pl</a><br/><br/>

        <ul class="social-icons">
          <li>
            <a target="_blank" href="http://karta.org.pl" class="social-icon">
              <i class="fa fa-3x fa-globe"></i>
            </a>
          </li>
          <li>
            <a target="_blank" href="https://www.facebook.com/OsrodekKARTA/" class="social-icon">
              <i class="fa fa-3x fa-facebook"></i>
            </a>
          </li>
          <li>
            <a target="_blank" href="https://twitter.com/osrodekkarta" class="social-icon">
              <i class="fa fa-3x fa-twitter"></i>
            </a>
          </li>

          <li>
            <a target="_blank" href="https://www.youtube.com/channel/UCsCbgqBfQI9a1MyCKx8E3dg" class="social-icon">
              <i class="fa fa-3x fa-youtube"></i>
            </a>
          </li>
        </ul>
      </b-col>
      <b-col xl="6">
        <gmap-map
          :center="karta"
          :zoom="17"
          map-type-id="terrain"
          style="min-height: 300px"
        >
          <gmap-marker
          :position="karta"
          :draggable="false"
          ></gmap-marker>
        </gmap-map>
      </b-col>
    </b-row>

  </div>
</template>

<script>
export default {
  name: 'kontakt',
  data(){
    return {
      karta: {
        lat:52.2060729,
        lng:21.015674
      }
    }
  },
  metaInfo:{
    title: 'Kontakt',
    meta:[
      {name: 'description', content: 'Administratorem strony jest Fundacja Ośrodka KARTA. Fundacja Ośrodka KARTA ul. Narbutta 29 02-536 Warszawa Tel. (022) 848-07-12' },
      {name: 'og:url', content: 'http://akwilno.pl/kontakt' },
      {name: 'og:title', content: 'Kontakt' },
      {name: 'og:image', content: '/main/menu_logo.png' },
      {name: 'og:description', content: 'Administratorem strony jest Fundacja Ośrodka KARTA. Fundacja Ośrodka KARTA ul. Narbutta 29 02-536 Warszawa Tel. (022) 848-07-12' },
      {name: 'twitter:url', content: 'http://akwilno.pl/kontakt' },
      {name: 'twitter:title', content: 'Kontakt' },
      {name: 'witter:image', content: '/main/menu_logo.png' },
      {name: 'twitter:description', content: 'Administratorem strony jest Fundacja Ośrodka KARTA. Fundacja Ośrodka KARTA ul. Narbutta 29 02-536 Warszawa Tel. (022) 848-07-12' }
    ]
  }
}
</script>

<style scoped>
  @import url(https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.6.3/css/font-awesome.css);

  a.social-icon{text-decoration: none; color: #fff;}
  p > a:hover{color: #d9d9d9; text-decoration:  underline;}
  ul{padding:0; list-style: none;}

  .social-icon{color: #fff;}
  ul.social-icons{margin-top: 10px;}
  .social-icons li{
    vertical-align: top;
    display: inline;
    height: 100px;
  }
  .social-icons a{
    color: #fff;
    text-decoration: none;
  }
  .social-icons i{
    -o-transition: background-color .5s;
    -ms-transition: background-color .5s;
    -moz-transition: background-color .5s;
    -webkit-transition: background-color .5s;
    transition: background-color  .5s;
    padding:5% 5%;
  }
  .fa-facebook{
    padding: 5% 7% !important;
    background-color: #322f30;
  }
  .fa-facebook:hover{
    background-color: #3d5b99;
  }
  .fa-twitter {
    background-color: #322f30;
  }
  .fa-twitter:hover {
    background-color: #00aced;
  }
  .fa-globe {
    padding:5% 5.5% !important;
    background-color: #322f30;
  }
  .fa-globe:hover{
    background-color: #eb8231;
  }
  .fa-youtube {
    padding:10px 14px;
    background-color: #322f30;
  }
  .fa-youtube:hover {
    background-color: #e64a41;
  }
</style>



// WEBPACK FOOTER //
// src/components/kontakt.vue